import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import DashboardPage from "@/pages/DashboardPage";
import PostRidePage from "@/pages/PostRidePage";
import SearchRidesPage from "@/pages/SearchRidesPage";
import DriverRequestsPage from "@/pages/DriverRequestsPage";
import MyBookingsPage from "@/pages/MyBookingsPage";

import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import SafetyPage from "@/pages/SafetyPage";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/search" element={<SearchRidesPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/post-ride"
              element={
                <ProtectedRoute>
                  <PostRidePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/incoming-requests"
              element={
                <ProtectedRoute>
                  <DriverRequestsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-bookings"
              element={
                <ProtectedRoute>
                  <MyBookingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/safety"
              element={
                <ProtectedRoute>
                  <SafetyPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
